<template>
  <div>
      <!--  -->
       <div v-if="isShow">
         <div>
            <Toolbar />
            <Headers />
            <Appbar />
         </div>
        <!-- <div style="width:100%;height:2px;background: #0066BA;"></div> -->
       </div>
       <div>
            <RouterView/>
       </div>
       <div v-if="isShow">
          <bottom/>
       </div>
       <div v-if="isShow" style="position: fixed;right:5px;bottom:50px">
          <rightFixed/>
       </div>
  </div>
</template>

<script  setup>
import { useRouter, useRoute } from 'vue-router';
import { watch,onMounted,ref } from 'vue';
import Toolbar from '@/components/homePublic/toolbar.vue'; // @ is an alias to /src
import Headers from '@/components/homePublic/header.vue';
import Appbar from '@/components/homePublic/appbar.vue';
import bottom from '@/components/homePublic/bottom.vue';
import rightFixed from '@/components/homePublic/rightFixed.vue';
import api from '@/axios/api'
import { useStore } from 'vuex';
const store = useStore();
const router = useRouter();
const route = useRoute();
const isShow = ref(true);
watch(route, (newRoute) => {
    isShow.value = newRoute.path !== '/login'
       api.Login.getUserInfoApi().then(res => {
      if (res.data.code === 200) {
         store.commit('setshopcartnum',  res.data.data.userInfo.cart) 
         store.commit('setMklUserInfo',  res.data.data.userInfo)
      }
   }) 
})
// onMounted(()=>{
//    api.Login.getUserInfoApi().then(res => {
//       if (res.data.code === 200) {
//          store.commit('setshopcartnum',  res.data.data.userInfo.cart) 
//          store.commit('setMklUserInfo',  res.data.data.userInfo)
//       }
//    }) 
// })
</script>

<style>
*{
    margin: 0px;
    padding: 0px;
    /* list-style: none; */
    box-sizing: border-box;
    font-family: MicrosoftYaHei;
}
.el-checkbox__inner{
   --el-index-normal:0 !important
}
.el-table{
   --el-index-normal:0!important
}
.el-carousel__item, .el-carousel__item{
   z-index:0 !important;
}
</style>
